import { IModal, modalService } from '@gig/magic-common';
import { store } from '../../store';
import { RESPONSIBLE_GAMING_NAMESPACE } from '../../store/modules/responsible-gaming/responsible-gaming.constants';

class ResponsibleGamingModalService {
    private modalRef: IModal | null = null;

    open() {
        if (this.modalRef) {
            return;
        }

        store.dispatch(
            `${RESPONSIBLE_GAMING_NAMESPACE}/changeModalOpenState`,
            true,
        );

        const responsibleGamingModal = document.createElement(
            'magic-responsible-gaming-modal',
        );

        this.modalRef = modalService.open(
            'time-out-modal.title',
            responsibleGamingModal,
            { keepAfterClear: true, responsibleGaming: true } as any,
        );
    }

    close() {
        if (!this.modalRef) {
            return;
        }

        store.dispatch(
            `${RESPONSIBLE_GAMING_NAMESPACE}/changeModalOpenState`,
            false,
        );
        modalService.close(this.modalRef);
        this.modalRef = null;
    }

    clearModal() {
        this.modalRef = null;
    }
}

export const responsibleGamingModalService =
    new ResponsibleGamingModalService();
